import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Icon, Page, Tabs } from '@dixa/lib-shared-habla';
import { matchRoutes, useLocation } from 'react-router-dom';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { useCurrentUser, userHasRole } from 'utils/user';
const integrationsTabs = [
    {
        id: 'conversationCards',
        label: 'Conversation cards',
        path: '/settings/integrations',
        minimumRole: 'admin',
    },
    {
        id: 'apiTokens',
        label: 'API tokens',
        path: '/settings/integrations/api-tokens',
        minimumRole: 'admin',
    },
    {
        id: 'webhooks',
        label: 'Webhooks',
        path: '/settings/integrations/webhooks',
        minimumRole: 'admin',
    },
    {
        id: 'webformEndpoints',
        label: 'Webform endpoints',
        path: '/settings/integrations/webform-endpoints',
        minimumRole: 'admin',
    },
    {
        id: 'chatbots',
        label: 'Chatbots',
        path: '/settings/integrations/chatbots',
        minimumRole: 'admin',
    },
    {
        id: 'busylight',
        label: 'Busylight',
        path: '/settings/integrations/busylight',
    },
];
/** Displays the header for settings/integrations pages. */
export const SettingsIntegrationsPageHeader = () => {
    var _a;
    const location = useLocation();
    const navigate = useAppNavigate();
    const { user } = useCurrentUser();
    const accessibleTabs = integrationsTabs.filter((route) => (route === null || route === void 0 ? void 0 : route.minimumRole) ? userHasRole(user, route.minimumRole) : true);
    // Add wildcard after each path to cover all subroutes
    const routes = accessibleTabs.map((item) => (Object.assign(Object.assign({}, item), { path: `${item.path}/*` })));
    const matches = matchRoutes(routes, location);
    const currentRoute = (_a = matches === null || matches === void 0 ? void 0 : matches[0]) === null || _a === void 0 ? void 0 : _a.route;
    const handleTabChange = (id) => {
        var _a;
        const tabToGo = (_a = accessibleTabs.find((item) => item.id === id)) === null || _a === void 0 ? void 0 : _a.path;
        navigate({
            path: tabToGo,
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(Page.Head, { title: _jsxs(FlexBox, Object.assign({ gap: "200", alignItems: "center" }, { children: ["Integrations", accessibleTabs.length === 1 && (_jsxs(_Fragment, { children: [_jsx(Icon, { name: "angle-right" }), accessibleTabs[0].label] }))] })) }), accessibleTabs.length > 1 && (_jsx(Page.Tabs, { children: _jsx(Tabs, { selectedId: currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.id, tabs: accessibleTabs, onChange: (id) => handleTabChange(id) }) }))] }));
};
